// Swiss cities + popular cross-border destinations for airport-transfer landing pages.
// Distances (km) / durations (min) are approximate road values from Zürich Airport (ZRH).

export const toSlug = (name) =>
  name
    .toLowerCase()
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/[éèê]/g, "e")
    .replace(/ç/g, "c")
    .replace(/ß/g, "ss")
    .replace(/[./]/g, " ")
    .trim()
    .replace(/\s+/g, "-");

export const CANTONS = {
  ZH: "Zürich", BE: "Bern", LU: "Luzern", UR: "Uri", SZ: "Schwyz", OW: "Obwalden",
  NW: "Nidwalden", GL: "Glarus", ZG: "Zug", FR: "Freiburg", SO: "Solothurn",
  BS: "Basel-Stadt", BL: "Basel-Landschaft", SH: "Schaffhausen", AR: "Appenzell Ausserrhoden",
  AI: "Appenzell Innerrhoden", SG: "St. Gallen", GR: "Graubünden", AG: "Aargau",
  TG: "Thurgau", TI: "Tessin", VD: "Waadt", VS: "Wallis", NE: "Neuenburg",
  GE: "Genf", JU: "Jura", FL: "Liechtenstein", INT: "International",
};

// n=name, c=canton, km, min, h=highlights
const RAW = [
  { n: "Zürich", c: "ZH", km: 13, min: 20, h: ["Bahnhofstrasse", "Zürichsee", "Altstadt"] },
  { n: "Kloten", c: "ZH", km: 3, min: 8, h: ["Flughafen Zürich", "Stadtzentrum"] },
  { n: "Bülach", c: "ZH", km: 13, min: 16, h: ["Altstadt", "Stadtkirche"] },
  { n: "Winterthur", c: "ZH", km: 22, min: 25, h: ["Fotomuseum", "Technorama", "Altstadt"] },
  { n: "Dübendorf", c: "ZH", km: 9, min: 15, h: ["Flieger Flab Museum"] },
  { n: "Uster", c: "ZH", km: 22, min: 25, h: ["Schloss Uster", "Greifensee"] },
  { n: "Wetzikon", c: "ZH", km: 30, min: 32, h: ["Pfäffikersee"] },
  { n: "Dietikon", c: "ZH", km: 18, min: 22, h: ["Limmattal"] },
  { n: "Wädenswil", c: "ZH", km: 33, min: 35, h: ["Zürichsee", "Halbinsel Au"] },
  { n: "Horgen", c: "ZH", km: 28, min: 30, h: ["Zürichsee"] },
  { n: "Thalwil", c: "ZH", km: 24, min: 28, h: ["Seebad"] },
  { n: "Meilen", c: "ZH", km: 25, min: 30, h: ["Goldküste", "Zürichsee"] },
  { n: "Küsnacht", c: "ZH", km: 20, min: 25, h: ["Goldküste"] },
  { n: "Stäfa", c: "ZH", km: 33, min: 35, h: ["Weinbau", "Zürichsee"] },
  { n: "Rüti", c: "ZH", km: 42, min: 40, h: ["Oberland"] },
  { n: "Regensdorf", c: "ZH", km: 12, min: 16, h: ["Furttal"] },
  { n: "Wallisellen", c: "ZH", km: 8, min: 14, h: ["Glattzentrum"] },
  { n: "Opfikon", c: "ZH", km: 5, min: 10, h: ["Glattpark"] },
  { n: "Schlieren", c: "ZH", km: 18, min: 22, h: ["Limmattal"] },
  { n: "Adliswil", c: "ZH", km: 22, min: 26, h: ["Sihltal"] },
  { n: "Rapperswil", c: "SG", km: 42, min: 40, h: ["Schloss", "Rosenstadt", "Zürichsee"] },
  { n: "Pfäffikon SZ", c: "SZ", km: 38, min: 35, h: ["Alpamare", "Seedamm"] },
  { n: "Lachen", c: "SZ", km: 48, min: 42, h: ["Obersee"] },
  { n: "Einsiedeln", c: "SZ", km: 52, min: 50, h: ["Kloster Einsiedeln", "Sihlsee"] },
  { n: "Schwyz", c: "SZ", km: 60, min: 55, h: ["Bundesbriefmuseum", "Mythen"] },
  { n: "Brunnen", c: "SZ", km: 62, min: 58, h: ["Vierwaldstättersee"] },
  { n: "Küssnacht am Rigi", c: "SZ", km: 55, min: 50, h: ["Rigi", "Hohle Gasse"] },
  { n: "Zug", c: "ZG", km: 40, min: 40, h: ["Zugersee", "Altstadt", "Zytturm"] },
  { n: "Baar", c: "ZG", km: 42, min: 42, h: ["Höllgrotten"] },
  { n: "Cham", c: "ZG", km: 45, min: 44, h: ["Zugersee"] },
  { n: "Luzern", c: "LU", km: 62, min: 55, h: ["Kapellbrücke", "Löwendenkmal", "Vierwaldstättersee"] },
  { n: "Kriens", c: "LU", km: 66, min: 58, h: ["Pilatus"] },
  { n: "Emmen", c: "LU", km: 60, min: 55, h: ["Verkehrshaus in der Nähe"] },
  { n: "Sursee", c: "LU", km: 65, min: 55, h: ["Sempachersee", "Altstadt"] },
  { n: "Willisau", c: "LU", km: 75, min: 65, h: ["Städtli"] },
  { n: "Weggis", c: "LU", km: 68, min: 60, h: ["Rigi", "Vierwaldstättersee"] },
  { n: "Vitznau", c: "LU", km: 72, min: 65, h: ["Rigi Bahn", "See"] },
  { n: "Engelberg", c: "OW", km: 78, min: 70, h: ["Titlis", "Kloster"] },
  { n: "Sarnen", c: "OW", km: 72, min: 65, h: ["Sarnersee"] },
  { n: "Stans", c: "NW", km: 68, min: 60, h: ["Stanserhorn"] },
  { n: "Altdorf", c: "UR", km: 82, min: 70, h: ["Telldenkmal", "Gotthard-Route"] },
  { n: "Andermatt", c: "UR", km: 108, min: 90, h: ["Ski Arena", "Gotthard", "The Chedi"] },
  { n: "Glarus", c: "GL", km: 65, min: 60, h: ["Glärnisch", "Altstadt"] },
  { n: "Näfels", c: "GL", km: 60, min: 55, h: ["Freulerpalast"] },
  { n: "Braunwald", c: "GL", km: 78, min: 75, h: ["autofreies Bergdorf"] },
  { n: "Elm", c: "GL", km: 90, min: 85, h: ["Martinsloch", "Sardona"] },
  { n: "Aarau", c: "AG", km: 45, min: 40, h: ["Altstadt", "Dachgiebel"] },
  { n: "Baden", c: "AG", km: 25, min: 28, h: ["Bäderquartier", "Altstadt"] },
  { n: "Wettingen", c: "AG", km: 25, min: 28, h: ["Kloster Wettingen"] },
  { n: "Brugg", c: "AG", km: 32, min: 32, h: ["Vindonissa", "Altstadt"] },
  { n: "Lenzburg", c: "AG", km: 45, min: 40, h: ["Schloss Lenzburg"] },
  { n: "Wohlen", c: "AG", km: 42, min: 40, h: ["Freiamt"] },
  { n: "Zofingen", c: "AG", km: 55, min: 48, h: ["Altstadt", "Heiternplatz"] },
  { n: "Rheinfelden", c: "AG", km: 75, min: 60, h: ["Altstadt", "Rhein", "Sole Uno"] },
  { n: "Bremgarten", c: "AG", km: 38, min: 38, h: ["Reussbrücke"] },
  { n: "Muri", c: "AG", km: 50, min: 48, h: ["Klosterkirche"] },
  { n: "Basel", c: "BS", km: 90, min: 65, h: ["Münster", "Kunstmuseum", "Rheinschwimmen"] },
  { n: "Riehen", c: "BS", km: 92, min: 68, h: ["Fondation Beyeler"] },
  { n: "Liestal", c: "BL", km: 80, min: 62, h: ["Altstadt", "Chienbäse"] },
  { n: "Pratteln", c: "BL", km: 82, min: 62, h: ["Grün 80"] },
  { n: "Allschwil", c: "BL", km: 92, min: 68, h: ["Dorfkern"] },
  { n: "Olten", c: "SO", km: 55, min: 48, h: ["Alte Holzbrücke", "Altstadt"] },
  { n: "Solothurn", c: "SO", km: 92, min: 70, h: ["St. Ursen Kathedrale", "Barockstadt"] },
  { n: "Grenchen", c: "SO", km: 100, min: 75, h: ["Uhrenstadt", "Grenchenberg"] },
  { n: "Bern", c: "BE", km: 125, min: 80, h: ["Bundeshaus", "Zytglogge", "Altstadt (UNESCO)"] },
  { n: "Thun", c: "BE", km: 145, min: 90, h: ["Schloss Thun", "Thunersee"] },
  { n: "Interlaken", c: "BE", km: 130, min: 95, h: ["Jungfrau", "Harder Kulm", "Höhematte"] },
  { n: "Spiez", c: "BE", km: 150, min: 95, h: ["Schloss Spiez", "Thunersee"] },
  { n: "Grindelwald", c: "BE", km: 155, min: 115, h: ["Eiger", "First", "Jungfraujoch"] },
  { n: "Wengen", c: "BE", km: 160, min: 130, h: ["autofrei", "Lauberhorn"] },
  { n: "Mürren", c: "BE", km: 165, min: 135, h: ["Schilthorn", "autofrei"] },
  { n: "Lauterbrunnen", c: "BE", km: 158, min: 120, h: ["Staubbachfall", "72 Wasserfälle"] },
  { n: "Adelboden", c: "BE", km: 175, min: 120, h: ["Weltcup", "Engstligenfälle"] },
  { n: "Gstaad", c: "BE", km: 200, min: 140, h: ["Promenade", "Ski", "Luxusresort"] },
  { n: "Biel", c: "BE", km: 110, min: 78, h: ["Bielersee", "Uhrenindustrie"] },
  { n: "Burgdorf", c: "BE", km: 115, min: 80, h: ["Schloss Burgdorf"] },
  { n: "Langenthal", c: "BE", km: 80, min: 62, h: ["Porzellan"] },
  { n: "Langnau", c: "BE", km: 130, min: 90, h: ["Emmental", "Käse"] },
  { n: "Meiringen", c: "BE", km: 135, min: 100, h: ["Reichenbachfall", "Sherlock Holmes"] },
  { n: "Kandersteg", c: "BE", km: 175, min: 120, h: ["Oeschinensee"] },
  { n: "Zweisimmen", c: "BE", km: 185, min: 130, h: ["GoldenPass"] },
  { n: "Freiburg", c: "FR", km: 160, min: 100, h: ["Altstadt", "Kathedrale St. Niklaus"] },
  { n: "Murten", c: "FR", km: 150, min: 95, h: ["Stadtmauer", "Murtensee"] },
  { n: "Bulle", c: "FR", km: 185, min: 120, h: ["Gruyère-Region"] },
  { n: "Gruyères", c: "FR", km: 195, min: 125, h: ["Schloss", "Käse", "Maison Cailler"] },
  { n: "Schaffhausen", c: "SH", km: 50, min: 45, h: ["Munot", "Rheinfall nahe"] },
  { n: "Neuhausen", c: "SH", km: 48, min: 42, h: ["Rheinfall"] },
  { n: "St. Gallen", c: "SG", km: 80, min: 60, h: ["Stiftsbibliothek (UNESCO)", "Textil"] },
  { n: "Gossau", c: "SG", km: 78, min: 60, h: ["Fürstenland"] },
  { n: "Wil", c: "SG", km: 55, min: 48, h: ["Hof zu Wil", "Altstadt"] },
  { n: "Uzwil", c: "SG", km: 65, min: 52, h: ["Industrie"] },
  { n: "Buchs SG", c: "SG", km: 100, min: 75, h: ["Werdenberg", "Rheintal"] },
  { n: "Sargans", c: "SG", km: 105, min: 78, h: ["Schloss Sargans"] },
  { n: "Bad Ragaz", c: "SG", km: 115, min: 80, h: ["Tamina Therme", "Grand Resort"] },
  { n: "Rorschach", c: "SG", km: 85, min: 65, h: ["Bodensee", "Kornhaus"] },
  { n: "Wattwil", c: "SG", km: 65, min: 58, h: ["Toggenburg"] },
  { n: "Herisau", c: "AR", km: 85, min: 65, h: ["Appenzellerland"] },
  { n: "Teufen", c: "AR", km: 88, min: 68, h: ["Zahnradbahn"] },
  { n: "Heiden", c: "AR", km: 92, min: 72, h: ["Biedermeierdorf"] },
  { n: "Appenzell", c: "AI", km: 95, min: 78, h: ["Hauptgasse", "Alpstein", "Ebenalp"] },
  { n: "Frauenfeld", c: "TG", km: 35, min: 35, h: ["Schloss", "Altstadt"] },
  { n: "Weinfelden", c: "TG", km: 50, min: 45, h: ["Weinbau"] },
  { n: "Kreuzlingen", c: "TG", km: 62, min: 55, h: ["Bodensee", "Konstanz"] },
  { n: "Amriswil", c: "TG", km: 68, min: 55, h: ["Bodensee-Region"] },
  { n: "Romanshorn", c: "TG", km: 70, min: 58, h: ["Bodensee-Hafen"] },
  { n: "Arbon", c: "TG", km: 75, min: 60, h: ["Bodensee", "Schloss"] },
  { n: "Stein am Rhein", c: "SH", km: 58, min: 52, h: ["Altstadt", "Rathausplatz"] },
  { n: "Diessenhofen", c: "TG", km: 52, min: 48, h: ["Holzbrücke"] },
  { n: "Chur", c: "GR", km: 130, min: 90, h: ["älteste Stadt", "Altstadt", "Brambrüesch"] },
  { n: "Davos", c: "GR", km: 150, min: 115, h: ["Ski", "WEF", "Jakobshorn"] },
  { n: "Klosters", c: "GR", km: 158, min: 118, h: ["Ski", "Madrisa"] },
  { n: "Arosa", c: "GR", km: 155, min: 120, h: ["Bärenland", "Ski"] },
  { n: "Lenzerheide", c: "GR", km: 148, min: 110, h: ["Ski", "Rothorn"] },
  { n: "Flims", c: "GR", km: 138, min: 100, h: ["Caumasee", "Ski"] },
  { n: "Laax", c: "GR", km: 142, min: 105, h: ["Snowpark", "Ski"] },
  { n: "St. Moritz", c: "GR", km: 200, min: 150, h: ["Ski", "Jetset", "Corviglia"] },
  { n: "Pontresina", c: "GR", km: 205, min: 155, h: ["Engadin", "Bernina"] },
  { n: "Celerina", c: "GR", km: 202, min: 152, h: ["Engadin"] },
  { n: "Zuoz", c: "GR", km: 210, min: 158, h: ["Engadiner Dorf"] },
  { n: "Scuol", c: "GR", km: 230, min: 170, h: ["Bogn Engiadina", "Unterengadin"] },
  { n: "Samnaun", c: "GR", km: 240, min: 180, h: ["zollfrei", "Ski"] },
  { n: "Disentis", c: "GR", km: 150, min: 120, h: ["Kloster", "Surselva"] },
  { n: "Savognin", c: "GR", km: 175, min: 135, h: ["Ski", "Familienregion"] },
  { n: "Bellinzona", c: "TI", km: 175, min: 130, h: ["3 Burgen (UNESCO)", "Altstadt"] },
  { n: "Lugano", c: "TI", km: 210, min: 150, h: ["Lago di Lugano", "Monte Brè"] },
  { n: "Locarno", c: "TI", km: 200, min: 145, h: ["Lago Maggiore", "Filmfestival", "Cardada"] },
  { n: "Ascona", c: "TI", km: 202, min: 148, h: ["Seepromenade", "Monte Verità"] },
  { n: "Mendrisio", c: "TI", km: 225, min: 160, h: ["Outlet", "Weinregion"] },
  { n: "Lausanne", c: "VD", km: 240, min: 150, h: ["Kathedrale", "Olympisches Museum", "Ouchy"] },
  { n: "Montreux", c: "VD", km: 260, min: 160, h: ["Jazz Festival", "Schloss Chillon"] },
  { n: "Vevey", c: "VD", km: 255, min: 158, h: ["Chaplin's World", "Genfersee"] },
  { n: "Yverdon-les-Bains", c: "VD", km: 210, min: 135, h: ["Thermalbad"] },
  { n: "Nyon", c: "VD", km: 275, min: 168, h: ["Schloss", "Römer"] },
  { n: "Villars", c: "VD", km: 245, min: 160, h: ["Ski", "Alpen"] },
  { n: "Leysin", c: "VD", km: 245, min: 160, h: ["Ski", "Aussicht"] },
  { n: "Genf", c: "GE", km: 300, min: 180, h: ["Jet d'Eau", "UNO", "Genfersee"] },
  { n: "Carouge", c: "GE", km: 302, min: 182, h: ["italienisches Flair"] },
  { n: "Sion", c: "VS", km: 260, min: 165, h: ["Schlösser Valère & Tourbillon", "Weinregion"] },
  { n: "Sierre", c: "VS", km: 275, min: 172, h: ["Weinregion", "Sonnenstadt"] },
  { n: "Zermatt", c: "VS", km: 245, min: 200, h: ["Matterhorn", "autofrei", "Gornergrat"] },
  { n: "Saas-Fee", c: "VS", km: 250, min: 200, h: ["Gletscher", "autofrei"] },
  { n: "Verbier", c: "VS", km: 280, min: 185, h: ["Ski", "4 Vallées"] },
  { n: "Crans-Montana", c: "VS", km: 275, min: 180, h: ["Ski", "Golf"] },
  { n: "Brig", c: "VS", km: 220, min: 155, h: ["Stockalperschloss", "Simplon"] },
  { n: "Leukerbad", c: "VS", km: 265, min: 175, h: ["Thermalbad"] },
  { n: "Martigny", c: "VS", km: 285, min: 180, h: ["Fondation Gianadda", "Römer"] },
  { n: "Neuenburg", c: "NE", km: 155, min: 105, h: ["Neuenburgersee", "Altstadt"] },
  { n: "La Chaux-de-Fonds", c: "NE", km: 165, min: 115, h: ["Uhrmacherstadt (UNESCO)"] },
  { n: "Delémont", c: "JU", km: 110, min: 85, h: ["Altstadt", "Jura"] },
  { n: "Porrentruy", c: "JU", km: 130, min: 100, h: ["Schloss"] },
  { n: "Vaduz", c: "FL", km: 110, min: 78, h: ["Schloss Vaduz", "Kunstmuseum"] },
  { n: "Balzers", c: "FL", km: 115, min: 82, h: ["Burg Gutenberg"] },
  { n: "Flumserberg", c: "SG", km: 100, min: 80, h: ["Ski", "Walensee"] },
  { n: "Walenstadt", c: "SG", km: 95, min: 72, h: ["Walensee"] },
  { n: "Wildhaus", c: "SG", km: 90, min: 78, h: ["Toggenburg", "Säntis"] },
  { n: "Konstanz", c: "INT", km: 65, min: 55, h: ["Bodensee", "Konzil", "Altstadt"] },
  { n: "Friedrichshafen", c: "INT", km: 95, min: 75, h: ["Zeppelin Museum", "Bodensee"] },
  { n: "Lindau", c: "INT", km: 130, min: 90, h: ["Inselstadt", "Bodensee"] },
  { n: "Bregenz", c: "INT", km: 120, min: 85, h: ["Seebühne", "Bodensee"] },
  { n: "Feldkirch", c: "INT", km: 135, min: 95, h: ["Schattenburg", "Altstadt"] },
  { n: "Innsbruck", c: "INT", km: 265, min: 180, h: ["Goldenes Dachl", "Alpen"] },
  { n: "München", c: "INT", km: 300, min: 195, h: ["Marienplatz", "Oktoberfest"] },
  { n: "Stuttgart", c: "INT", km: 220, min: 150, h: ["Mercedes-Museum", "Schlossplatz"] },
  { n: "Freiburg im Breisgau", c: "INT", km: 120, min: 90, h: ["Münster", "Schwarzwald"] },
  { n: "Colmar", c: "INT", km: 160, min: 115, h: ["Petite Venise", "Elsass"] },
  { n: "Strasbourg", c: "INT", km: 230, min: 160, h: ["Münster", "EU-Parlament"] },
  { n: "Mailand", c: "INT", km: 280, min: 180, h: ["Dom", "Shopping", "Malpensa"] },
  { n: "Como", c: "INT", km: 260, min: 165, h: ["Comer See", "Altstadt"] },
  { n: "Opfikon-Glattbrugg", c: "ZH", km: 5, min: 10, h: ["Airport-Hotels"] },
  { n: "Rümlang", c: "ZH", km: 6, min: 12, h: ["Flughafennähe"] },
  { n: "Wangen-Brüttisellen", c: "ZH", km: 10, min: 15, h: ["Glattal"] },
  { n: "Volketswil", c: "ZH", km: 15, min: 20, h: ["Einkaufszentrum"] },
  { n: "Dietlikon", c: "ZH", km: 10, min: 16, h: ["Industrie"] },
  { n: "Kloten Balsberg", c: "ZH", km: 4, min: 9, h: ["Bahnhof"] },
  { n: "Illnau-Effretikon", c: "ZH", km: 18, min: 22, h: ["Zürcher Oberland"] },
  { n: "Bassersdorf", c: "ZH", km: 9, min: 14, h: ["Nähe Flughafen"] },
  { n: "Nürensdorf", c: "ZH", km: 12, min: 17, h: ["ländlich"] },
  { n: "Kloten Industrie", c: "ZH", km: 4, min: 10, h: ["Gewerbe"] },
  { n: "Zollikon", c: "ZH", km: 16, min: 22, h: ["Goldküste"] },
  { n: "Zumikon", c: "ZH", km: 20, min: 26, h: ["Wohnlage"] },
  { n: "Erlenbach", c: "ZH", km: 22, min: 28, h: ["Zürichsee"] },
  { n: "Herrliberg", c: "ZH", km: 24, min: 30, h: ["Seeblick"] },
  { n: "Wetzikon-Kempten", c: "ZH", km: 30, min: 32, h: ["Oberland"] },
  { n: "Bülach Nord", c: "ZH", km: 15, min: 18, h: ["Unterland"] },
  { n: "Kloten Flughafen Terminal", c: "ZH", km: 1, min: 5, h: ["Terminal 1 & 2"] },
  { n: "Affoltern am Albis", c: "ZH", km: 30, min: 32, h: ["Knonaueramt"] },
  { n: "Zug Oberwil", c: "ZG", km: 44, min: 45, h: ["Zugersee"] },
  { n: "Rotkreuz", c: "ZG", km: 48, min: 46, h: ["Verkehrsknoten"] },
  { n: "Hünenberg", c: "ZG", km: 47, min: 46, h: ["ländlich"] },
  { n: "Menzingen", c: "ZG", km: 50, min: 52, h: ["Voralpen"] },
  { n: "Küssnacht Immensee", c: "SZ", km: 55, min: 50, h: ["Rigi", "See"] },
  { n: "Wollerau", c: "SZ", km: 35, min: 33, h: ["Steueroase", "Seeblick"] },
  { n: "Freienbach", c: "SZ", km: 37, min: 35, h: ["Zürichsee"] },
  { n: "Arth-Goldau", c: "SZ", km: 58, min: 52, h: ["Rigi", "Tierpark"] },
  { n: "Sursee Nord", c: "LU", km: 66, min: 56, h: ["Sempachersee"] },
  { n: "Hochdorf", c: "LU", km: 55, min: 50, h: ["Baldeggersee"] },
  { n: "Hergiswil", c: "NW", km: 66, min: 58, h: ["Glasi", "Vierwaldstättersee"] },
  { n: "Beckenried", c: "NW", km: 72, min: 62, h: ["Klewenalp"] },
  { n: "Flüelen", c: "UR", km: 80, min: 68, h: ["Urnersee"] },
  { n: "Erstfeld", c: "UR", km: 88, min: 74, h: ["Gotthard"] },
  { n: "Wil Nord", c: "SG", km: 56, min: 49, h: ["Fürstenland"] },
  { n: "Flawil", c: "SG", km: 70, min: 55, h: ["Fürstenland"] },
  { n: "Altstätten", c: "SG", km: 95, min: 72, h: ["Rheintal"] },
  { n: "Rheineck", c: "SG", km: 90, min: 68, h: ["Bodensee"] },
  { n: "Widnau", c: "SG", km: 98, min: 74, h: ["Rheintal"] },
  { n: "Frauenfeld Ost", c: "TG", km: 37, min: 36, h: ["Thurgau"] },
  { n: "Aarburg", c: "AG", km: 56, min: 49, h: ["Festung"] },
  { n: "Möhlin", c: "AG", km: 78, min: 62, h: ["Fricktal"] },
  { n: "Klingnau", c: "AG", km: 45, min: 42, h: ["Klingnauer Stausee"] },
  { n: "Zurzach", c: "AG", km: 42, min: 42, h: ["Thermalbad"] },
  { n: "Grenchen Süd", c: "SO", km: 100, min: 75, h: ["Uhren"] },
  { n: "Ostermundigen", c: "BE", km: 128, min: 82, h: ["bei Bern"] },
  { n: "Köniz", c: "BE", km: 130, min: 84, h: ["bei Bern"] },
  { n: "Worb", c: "BE", km: 132, min: 86, h: ["Emmental-Tor"] },
  { n: "Saanen", c: "BE", km: 202, min: 142, h: ["Gstaad-Region"] },
  { n: "Nyon Süd", c: "VD", km: 276, min: 168, h: ["Genfersee"] },
  { n: "Morges", c: "VD", km: 250, min: 155, h: ["Genfersee", "Schloss"] },
  { n: "Aigle", c: "VD", km: 235, min: 152, h: ["Weinregion", "Schloss"] },
  { n: "Monthey", c: "VS", km: 250, min: 158, h: ["Portes du Soleil"] },
  { n: "Visp", c: "VS", km: 225, min: 160, h: ["Zermatt-Tor"] },
  { n: "Täsch", c: "VS", km: 240, min: 195, h: ["Zermatt Terminal"] },
];

export const CITIES = RAW.map((x) => ({
  name: x.n,
  canton: x.c,
  cantonName: CANTONS[x.c] || x.c,
  km: x.km,
  min: x.min,
  highlights: x.h || [],
  slug: toSlug(x.n),
  path: `/flughafentransfer-${toSlug(x.n)}`,
}));

export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);

// A curated set of popular routes for the footer / homepage.
export const POPULAR = [
  "Bern", "Luzern", "Basel", "St. Gallen", "Zug", "Davos", "St. Moritz",
  "Zermatt", "Interlaken", "Chur", "Lugano", "Genf", "Lausanne", "Grindelwald",
  "Arosa", "Gstaad", "Vaduz", "Konstanz",
].map((n) => CITIES.find((c) => c.name === n)).filter(Boolean);

// ---- Per-city blog images (regionally themed Swiss photo pool) ----
const IMG = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200`;
const IMG_POOL = {
  mountain: [
    "photo-1667748146658-03598c9f5721", "photo-1622513027693-3ef7c21b3dae",
    "photo-1605750454112-f2f3f696eeb0", "photo-1605750454069-3a7a6ba752cd",
    "photo-1527668752968-14dc70a27c95", "photo-1521292270410-a8c4d716d518",
  ].map(IMG),
  lake: [
    "photo-1658093271921-199c7a03edc6", "photo-1657908490925-c763849b4e13",
    "photo-1707654300983-184e78c77457", "photo-1719664844798-19c6296fd6f6",
  ].map(IMG),
  city: [
    "photo-1597758468241-e312af40d7e9", "photo-1664459937096-d395cd77f8b8",
    "photo-1664459937301-03c3e6e453b6", "photo-1778660033564-b3c4caa261eb",
    "photo-1658738795717-3fd594f4e1a9", "photo-1623053053418-5c321e9376c5",
    "photo-1765054776840-514d966ec390",
  ].map(IMG),
};
const CANTON_THEME = {
  VS: "mountain", GR: "mountain", GL: "mountain", UR: "mountain", OW: "mountain",
  NW: "mountain", BE: "mountain", AI: "mountain", AR: "mountain",
  LU: "lake", SZ: "lake", ZG: "lake", TI: "lake", VD: "lake", GE: "lake", NE: "lake",
};

export const cityImage = (city) => {
  const pool = IMG_POOL[CANTON_THEME[city.canton] || "city"];
  const s = city.slug || city.name || "";
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return pool[h % pool.length];
};
